import { BaseSystemModel, RecursivePartial } from '@models/base';
import { ParamsFilter } from '@models/filters';

export class TasksFilter extends BaseSystemModel {
    _type = BaseSystemModel.Type.TasksFilter;

    name: string = '';
    icon: string = 'vzi-filter';
    color: string = '#ccc';
    filter?: ParamsFilter;
    filterText?: string;

    constructor(json?: RecursivePartial<TasksFilter>) {
        super(json);
        this.parseTasksFilter(json || {});
    }

    parse(json: RecursivePartial<TasksFilter>): TasksFilter {
        super.parse(json);
        this.parseTasksFilter(json);
        return this;
    }

    private parseTasksFilter(json: RecursivePartial<TasksFilter>): void {
        TasksFilter.assignFields<TasksFilter>(this, json, ['name', 'icon', 'color', 'filterText']);
        TasksFilter.assignClassFields<TasksFilter>(this, json, { filter: ParamsFilter });
    }

}
